const helpers = {
  openContactDrawer: () => {
    let drawer = document.getElementsByClassName("contact-drawer")[0];
    drawer.classList.remove("contact-drawer--close");

    if (window.innerWidth > 375) {
      drawer.classList.add("contact-drawer--open-desktop");
    } else {
      drawer.classList.add("contact-drawer--open-mobile");
    }
  },
  openMenuDrawer: () => {
    let drawer = document.getElementsByClassName("menu-drawer")[0];
    drawer.classList.remove("menu-drawer--close");

    if (window.innerWidth > 375) {
      drawer.classList.add("menu-drawer--open--desktop");
    } else {
      drawer.classList.add("menu-drawer--open--mobile");
    }
  },
};

export default helpers;
